module.exports = __webpack_public_path__ + "img/illustrator.84c5e954.png";